import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from '@mui/material';
import { StyledAccordionSubHeader } from './Styled';
const LeadAccordion = (props) => {
  return (
    <React.Fragment>
      <Accordion style={{marginTop: "15px"}} defaultExpanded={props.defaultOpen || false} expanded={props.expanded}  {...props}>
        <AccordionSummary
          sx={{
            // flexDirection: "row-reverse",
            // "& .MuiAccordionSummary-expandIconWrapper": {
            //     transform: "rotate(-90deg)"
          
            // }
           }}
          expandIcon={<ExpandMoreIcon />}
          
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <StyledAccordionSubHeader>
                    {props.label}
          </StyledAccordionSubHeader>
                          
          {/* <Typography variant="subtitle2">{props.label}</Typography> */}
        </AccordionSummary>
        <AccordionDetails>
          {props.children}
        </AccordionDetails>
      </Accordion>
      {props?.isHorizontalbar && <Divider />}
    </React.Fragment>
  );
}

export default LeadAccordion;